// The quote so far while the Quote Brain writes a job (lucid 019 O2): the run banner reads it with each poll of the run
// (GET /api/brain/runs/:id `working`) and puts it here, and Stage 4 shows it. One read serves both, so Stage 4 never polls.
import { useSyncExternalStore } from 'react';
import type { QuoteBrainWorking } from '../services/quote-brain-runs';

const byProject = new Map<string, QuoteBrainWorking>();
const listeners = new Set<() => void>();

const key = (projectId: unknown) => (projectId == null ? '' : String(projectId));

/** The banner's latest read for the job; null clears it (the run stopped, or the banner left the job). */
export function noteQuoteBrainWorking(projectId: unknown, working: QuoteBrainWorking | null | undefined): void {
    const id = key(projectId);
    if (!id) return;
    if (!working) {
        if (!byProject.has(id)) return;
        byProject.delete(id);
    } else {
        byProject.set(id, working);
    }
    listeners.forEach((fn) => fn());
}

export function quoteBrainWorking(projectId: unknown): QuoteBrainWorking | null {
    return byProject.get(key(projectId)) || null;
}

function subscribe(fn: () => void): () => void {
    listeners.add(fn);
    return () => { listeners.delete(fn); };
}

export function useQuoteBrainWorking(projectId: unknown): QuoteBrainWorking | null {
    return useSyncExternalStore(subscribe, () => quoteBrainWorking(projectId), () => quoteBrainWorking(projectId));
}

/** Tests only. */
export function __resetQuoteBrainWorking(): void {
    byProject.clear();
    listeners.forEach((fn) => fn());
}
